module.exports = __webpack_public_path__ + "cbcf1e85df9939d67d399993edf2a2b6.svg";